import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/IntentActionTypes";
import _ from "lodash";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";
import { fetchAccountList } from "./accountAction";


export const setIntentUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_INTENT", payload: null });
    };
};



export const getSideBarData = (authToken) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get(
            "intent/get_company_info",
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "SIDEBAR_DATA", payload: response.data });
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
        // Toast(err.response, "E");
      }
    };
  };
  export const getFollowList = (authToken,filter) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get(
            `intent/get-follow-list?search=&filter=${filter}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "FOLLOW_LIST", payload: response.data });
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
        // Toast(err.response, "E");
      }
    };
  };
  export const getFollowListSetup = (authToken,filter) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get(
            `intent/get-followed-list?search=&type=""`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "FOLLOW_LIST_SETUP", payload: response.data });
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
        // Toast(err.response, "E");
      }
    };
  };

  export const getReportData = (authToken, id) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      dispatch({ type: "REPORT_DATA_MORE", payload: true });
      const fetchReportStatus = async () => {
        try {
          const response = await storeApis.post("intent/get-playground-report-genration",
            { playground_report_id: id },
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
  
          if (response.status === 200) {
            if (response.data.statusCode === "403") {
              dispatch({
                type: "UNAUTHORIZED_INTENT",
                payload: response.data.statusCode,
              });
              dispatch({ type: "TOGGLE_LOADING", payload: false });
              dispatch({ type: "REPORT_DATA_MORE", payload: false });

              clearInterval(intervalId);
            } else {
              // dispatch({ type: "REPORT_DATA_MORE", payload: response?.data?.response_data?.data?.report_status });
              console.log(response?.data?.response_data?.data?.report_status,"bhar")
              if (response?.data?.response_data?.data?.report_status === "completed" || response?.data?.response_data?.data?.report_status === "failed") {
                // dispatch({ type: "REPORT_DATA", payload: response.data?.data });
                dispatch({ type: "TRIGGER_REPORT", payload: response?.data?.response_data?.data?.data });
                dispatch({ type: "TOGGLE_LOADING", payload: false });
                dispatch({ type: "REPORT_DATA_MORE", payload: false });
                clearInterval(intervalId);
              }
              
            }
          }
        } catch (err) {
          console.log("ERROR", err);
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "REPORT_DATA_MORE", payload: false });

          dispatch({
            type: "UNAUTHORIZED_INTENT",
            payload: err.response.status,
          });
          clearInterval(intervalId);
        }
      };
  
      const intervalId = setInterval(fetchReportStatus, 30000);
        fetchReportStatus(); // Initial call
    };
  };
  

  export const getReport = (authToken,payload) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("/intent/create_intent_report",
        payload,
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch(getReportData(authToken,response.data?.report_id));
            dispatch({ type: "REPORT_ID", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };
  export const getIntelReport = (authToken, id) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/get-news-report",
        { follow_id: id },
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch({ type: "NEWS_REPORT", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };


  export const getTriggerList = (authToken) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get(
            "intent/trigger-list",
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "TRIGGER_LIST", payload: response.data });
          }
        }
      } catch (err) {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
        // Toast(err.response, "E");
      }
    };
  };


  export const getTriggerReport = (authToken,payload) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/playground-report-genration",
        payload,
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch(getReportData(authToken,response.data?.playground_report_id));
            dispatch({ type: "REPORT_ID", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };

  
  export const saveTriggers = (authToken,payload) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/trigger-settings",
        payload,
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            Toast("Saved", "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };


  export const getTrackingList = (authToken,search,type) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/tracking-list",
        {
          search,type
        },
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "TRACKING_LIST", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };


  export const getGmailContent = (authToken, aid,fid,lid,ty) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/create-email",
        {
        article_id: aid,
        follow_id:fid,
        lead_id:lid,
        type:ty },
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch({ type: "EMAIL_DATA", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };
  export const intentFavorite = (authToken,fid,type,filter,t) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post("intent/save-favorite",
        {
        is_favorite:type,
        follow_id:fid
      },
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            // dispatch({ type: "EMAIL_DATA", payload: response.data });
            if(t == "track"){
              dispatch(getIntelReport(authToken, fid));
              dispatch(getFollowList(authToken,filter));
            }else{
              dispatch(fetchAccountList(authToken,"",1));
            }
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };
  export const getIndustryData = (authToken) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get("/exprience-zoi/industry-list",
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch({ type: "INDUSTRY_DATA", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };
  export const getTriggerData = (authToken) => {
    return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get("/exprience-zoi/triggers-list",
         {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_INTENT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            //   console.log(response.data,"imp")
            dispatch({ type: "TRIGGER_DATA", payload: response.data });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "S");
          }
        }
      } catch (err) {
        console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_INTENT",
          payload: err.response.status,
        });
      }
    };
  };



  

  